<div class="dt-panel" [class.expanded]="expanded()">
  <!-- Header - shown only on home screen -->
  @if (currentView() === 'home') {
    <div class="header">
      <span class="title">Dev Tools</span>
      <div class="actions">
        <button
          class="dt-btn icon expand-btn"
          (click)="toggleExpanded()"
          type="button"
          [attr.aria-label]="expanded() ? 'Collapse panel' : 'Expand panel'"
          [title]="expanded() ? 'Collapse' : 'Expand'"
        >
          <iris-icon
            [name]="expanded() ? 'arrow_drop_down' : 'arrow_line_up'"
            [size]="iconSizes.SM"
          ></iris-icon>
        </button>
        <button
          class="dt-btn icon"
          (click)="closePanel()"
          type="button"
          aria-label="Close panel"
        >
          <iris-icon name="close" [size]="iconSizes.SM"></iris-icon>
        </button>
      </div>
    </div>
  }

  <!-- Content area -->
  <div class="content">
    @if (currentView() === 'home') {
      <dev-tools-home (toolSelected)="navigateToTool($event)"></dev-tools-home>
    } @else if (currentView() === 'segment-preview') {
      <segment-preview-tool (back)="navigateToHome()"></segment-preview-tool>
    } @else if (currentView() === 'amplitude-flags') {
      <amplitude-flag-tool (back)="navigateToHome()"></amplitude-flag-tool>
    }
  </div>

  <!-- Close button for tool views (floating) -->
  @if (currentView() !== 'home') {
    <button
      class="close-tool"
      (click)="closePanel()"
      type="button"
      aria-label="Close panel"
      title="Close"
    >
      <iris-icon name="close" [size]="iconSizes.SM"></iris-icon>
    </button>
  }
</div>
